import { Heart, Flame, Droplet, Flower2 } from "lucide-react";

const productDetails = [
  {
    icon: Flame,
    title: "Scented Candles",
    body:
      "Carefully crafted to create warm, inviting environments that promote relaxation, peace, and meaningful moments.",
    image: "/assets/products/candle_12oz.jpg",
    testid: "detail-candles",
  },
  {
    icon: Droplet,
    title: "Hair Growth Oils",
    body:
      "Formulated with nourishing ingredients to support healthy hair growth, strength, moisture retention, and overall hair wellness.",
    image: "/assets/hair_oils.jpg",
    testid: "detail-oils",
  },
  {
    icon: Flower2,
    title: "Floral Planters",
    body:
      "Thoughtfully designed to add natural beauty, color, and life to homes, offices, patios, and special occasions.",
    image: "/assets/products/planter_large.jpg",
    testid: "detail-planters",
  },
];

export default function HandcraftedPurpose() {
  return (
    <section
      data-testid="handcrafted-purpose-section"
      className="relative bg-brand-cream py-24 lg:py-32 overflow-hidden"
    >
      {/* Brand watercolor decorations */}
      <img src="/assets/flower_cosmos.png" alt="" aria-hidden="true" className="absolute -top-4 -left-6 w-60 lg:w-72 opacity-85 animate-float-slow pointer-events-none hidden md:block" />
      <img src="/assets/flower_rose.png" alt="" aria-hidden="true" className="absolute -bottom-4 -right-4 w-60 lg:w-80 opacity-90 animate-drift pointer-events-none hidden md:block" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12 relative z-10">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-block relative">
            <span className="absolute inset-0 bg-[#5D2138]/95 -rotate-1 -skew-x-2 rounded" />
            <span className="relative px-6 py-2 text-brand-cream text-xs uppercase tracking-[0.4em] font-sans inline-block">
              Handcrafted with Purpose. <Heart className="inline w-3 h-3 ml-1 fill-current text-brand-gold" />
            </span>
          </div>

          <h2 className="mt-7 font-script text-6xl lg:text-7xl text-[#B7574E] leading-none">
            Made for You.
          </h2>

          <p className="mt-7 text-lg text-brand-ink/80 leading-relaxed max-w-xl mx-auto">
            Every product is handcrafted in small batches using high-quality ingredients and a whole
            lot of prayer. Whether you&apos;re treating yourself or gifting someone special, you&apos;re
            choosing products that make a difference.
          </p>
        </div>

        <div className="mt-16 space-y-12 lg:space-y-16">
          {productDetails.map((d, idx) => {
            const Icon = d.icon;
            const reversed = idx % 2 === 1;
            return (
              <div
                key={d.testid}
                data-testid={d.testid}
                className={`grid lg:grid-cols-12 gap-8 lg:gap-14 items-center ${
                  reversed ? "lg:[&>*:first-child]:order-2" : ""
                }`}
              >
                <div className="lg:col-span-5">
                  <div className="relative aspect-[4/5] rounded-3xl overflow-hidden border border-brand-moss/15 shadow-md">
                    <img src={d.image} alt={d.title} className="absolute inset-0 w-full h-full object-cover" />
                  </div>
                </div>
                <div className="lg:col-span-7">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-moss text-brand-gold mb-5">
                    <Icon className="w-7 h-7" strokeWidth={1.5} />
                  </div>
                  <h3 className="font-serif text-3xl lg:text-4xl text-brand-moss leading-tight tracking-tight uppercase">
                    {d.title}
                  </h3>
                  <p className="mt-5 text-lg text-brand-ink/75 leading-relaxed max-w-xl">
                    {d.body}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <p className="mt-20 text-center font-serif italic text-base lg:text-lg text-brand-moss/75 max-w-2xl mx-auto leading-relaxed">
          Thank you for supporting a small business built on faith, hard work, and love. <span className="text-brand-gold">♡</span>
        </p>
      </div>
    </section>
  );
}
